import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import FormFieldComponent from './js/form-field.component';

ComponentsFactory.getInstance().define('form-field', FormFieldComponent);
